import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  createTplActor: {
    id: 'createTplActor',
    defaultMessage: 'Create actor',
  },
  updateTplActor: {
    id: 'updateTplActor',
    defaultMessage: 'Update actor',
  },
  actorTpl: {
    id: 'actorTpl',
    defaultMessage: 'Actor template',
  },
  actorCreated: {
    id: 'actorCreated',
    defaultMessage: 'Actor has been successfully created',
  },
  uploadImage: {
    id: 'uploadImage',
    defaultMessage: 'Upload image',
  },
  changeImage: {
    id: 'changeImage',
    defaultMessage: 'Change image',
  },
  delImage: {
    id: 'delImage',
    defaultMessage: 'Delete image',
  },
});

export default { ...globalIntl, ...m };
